import {ClearanceStatusType} from "@app/shared/classes/employee";

export class Clearance {
  id: number;
  userId: number;
  clearanceGrantedOn: string;
  statusType: ClearanceStatusType;
  type: string;
  grantingInstitution: string;
  version: number;
  clearanceId: number;
}